import { IListItemProps, IOrderInfoDetails, IOrderInfoResponse, IPassageItem } from '../models';
interface IOrderInfoDetailsObject {
	[moduleType: string]: IOrderInfoDetails[];
}

export const getOrderEntriesSortedByModuleType = (orderData: IOrderInfoResponse): [string, IOrderInfoDetails[]][] => {
	const {
		orderInfo: { orderDetails },
	} = orderData;
	const orderItemsByModuleType = orderDetails
		.sort(({ moduleType: moduleTypeA }, { moduleType: moduleTypeB }) => moduleTypeB.localeCompare(moduleTypeA))
		.reduce((acc: IOrderInfoDetailsObject, orderItem) => {
			const { moduleType } = orderItem;
			acc[moduleType] = !acc[moduleType] ? [orderItem] : [...acc[moduleType], orderItem];
			return acc;
		}, {});
	return Object.entries(orderItemsByModuleType);
};

export const getOrderUrlParams = (location): string => {
	const urlParams = new URLSearchParams(location.search);
	const orderHash = urlParams.get('orderHash') ?? '';
	return orderHash;
};

export const formatAndSortPassages = (passages: IPassageItem[]): IListItemProps[] =>
	passages
		.map((p) => {
			const [month, day, yearAndTime] = p.passageDateTime.split('.');
			const passageDateTime = `${day} ${month} ${yearAndTime}`;
			return { ...p, passageDateTime };
		})
		.sort((a, b) => new Date(a.passageDateTime).getTime() - new Date(b.passageDateTime).getTime())
		.map(({ tollStationName, passageDateTime, price }) => ({
			label: tollStationName,
			subLabel: `${new Date(passageDateTime).toLocaleDateString('de-DE')}, ${new Date(
				passageDateTime,
			).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`,
			value: `${price.amount}€`,
		}));
